import React from 'react';
import PropTypes from 'prop-types';
import StateSelect from 'library/components/form-elements/state';
import CountrySelect from 'library/components/form-elements/country';
import { resolve } from 'library/helpers/path-resolver';
import LabelInput from 'library/components/unstyled-input';
import MonthSelect from 'library/components/form-elements/month';
import YearSelect from 'library/components/form-elements/year';

import 'apps/pathways/styles/start/main.scss';

class JobExperience extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.form = React.createRef();
    this.toggle = React.createRef();
  }

  render() {
    const { date_range, onChange, active } = this.props;

    const [start_year, start_month] = resolve(date_range, 'start', '--').split(
      '-'
    );
    const [finish_year, finish_month] = resolve(
      date_range,
      'finish',
      '--'
    ).split('-');

    return (
      <div className="experiences-form-container">
        <section>
          <LabelInput
            diffAriaLabel="Job Title"
            label="Job Title"
            required={active}
            disabled={!active}
            name="title"
            type="input"
            onChange={onChange}
            placeholder="Job Title"
            value={resolve(this.props, 'title', '')}
          />

          <LabelInput
            label="Company"
            required={active}
            disabled={!active}
            name="company"
            type="input"
            onChange={onChange}
            placeholder="Company"
            value={resolve(this.props, 'company', '')}
          />
        </section>

        <section>
          <LabelInput
            label="City"
            required={active}
            disabled={!active}
            name="city"
            type="input"
            onChange={onChange}
            placeholder="City"
            value={resolve(this.props, 'city', '')}
          />

          <label htmlFor="state">
            State
            <StateSelect
              name="state"
              disabled={!active}
              aria-label="state"
              aria-required="true"
              onChange={onChange}
              value={resolve(this.props, 'state', '')}
              id="name"
            />
          </label>
        </section>

        <section>
          <label htmlFor="country">
            Country
            <CountrySelect
              name="country"
              disabled={!active}
              aria-label="country"
              aria-required="true"
              onChange={onChange}
              value={resolve(this.props, 'country', '')}
              id="country"
            />
          </label>

          <label htmlFor="time-period">
            Time Period
            <div name="time-period" className="experience-select-group">
              <div name="start" className="experience-select-group">
                <MonthSelect
                  required={active}
                  onChange={onChange}
                  disabled={!active}
                  aria-label="start_month"
                  aria-required="true"
                  name="start_month"
                  id="start_month"
                  value={start_month}
                />
                <YearSelect
                  required={active}
                  onChange={onChange}
                  disabled={!active}
                  aria-label="start_year"
                  aria-required="true"
                  name="start_year"
                  id="start_year"
                  value={start_year}
                />
              </div>
              <span> TO </span>
              <div name="finish" className="experience-select-group">
                <MonthSelect
                  required={active}
                  onChange={onChange}
                  disabled={!active || resolve(this.props, 'is_current', false)}
                  aria-label="finish_month"
                  aria-required="true"
                  name="finish_month"
                  id="finish_month"
                  value={finish_month}
                />
                <YearSelect
                  required={active}
                  onChange={onChange}
                  disabled={!active || resolve(this.props, 'is_current', false)}
                  aria-label="finish_year"
                  aria-required="true"
                  name="finish_year"
                  id="finish_year"
                  value={finish_year}
                />
              </div>
            </div>
            <label htmlFor="is_current">
              Current job
              <input
                aria-label={`select if this is current job it is currently${
                  resolve(this.props, 'is_current', false)
                    ? 'checked'
                    : 'unchecked'
                }`}
                disabled={!active}
                type="checkbox"
                name="is_current"
                id="is_current"
                onChange={onChange}
                value={resolve(this.props, 'is_current', false)}
                checked={resolve(this.props, 'is_current', false)}
              />
            </label>
          </label>
        </section>

        <label className="experience-description" htmlFor="description">
          Description
          <textarea
            aria-label="this is a text area to describe your experience"
            required={active}
            disabled={!active}
            onChange={onChange}
            value={resolve(this.props, 'description', '')}
            name="description"
            id="description"
            rows={9}
          />
        </label>
      </div>
    );
  }
}

JobExperience.propTypes = {
  onChange: PropTypes.func,
  company: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  date_range: PropTypes.object,
  description: PropTypes.string,
  id: PropTypes.number,
  is_current: PropTypes.bool,
  state: PropTypes.string,
  title: PropTypes.string,
  active: PropTypes.bool,
};

export default JobExperience;
